var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "__TEMP__SVG__",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8253",
    "data-name": "Caminho 8253",
    d: "M31.5,2.25H4.5A2.25,2.25,0,0,0,2.25,4.5v27A2.25,2.25,0,0,0,4.5,33.75h27a2.25,2.25,0,0,0,2.25-2.25V4.5A2.25,2.25,0,0,0,31.5,2.25ZM4.5,0A4.5,4.5,0,0,0,0,4.5v27A4.5,4.5,0,0,0,4.5,36h27A4.5,4.5,0,0,0,36,31.5V4.5A4.5,4.5,0,0,0,31.5,0Z",
    fill: "#0092f6",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8254",
    "data-name": "Caminho 8254",
    d: "M10.454,17.2a1.125,1.125,0,0,1,1.593,0L18,23.159,23.954,17.2A1.126,1.126,0,1,1,25.547,18.8l-6.75,6.75a1.125,1.125,0,0,1-1.593,0l-6.75-6.75a1.125,1.125,0,0,1,0-1.593Z",
    fill: "#0092f6",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8255",
    "data-name": "Caminho 8255",
    d: "M18,10.125a1.125,1.125,0,0,1,1.125,1.125V22.5a1.125,1.125,0,0,1-2.25,0V11.25A1.125,1.125,0,0,1,18,10.125Z",
    fill: "#0092f6",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.32319eec4609c056f024ba3f8e100a99.svg";
export { ForwardRef as ReactComponent };